import { useState, useEffect, useCallback, useContext } from "react";
import { TextField, Grid } from "@material-ui/core";

import "./personalInformation.css";
import { formatSSN } from "../../../../../../../../../utils/commonFunctions/SSN";
import { formatZIP } from "../../../../../../../../../utils/commonFunctions/ZIP";
import prefixCharacterAddition from "../../../../../../../../../utils/commonFunctions/prefixCharacterAddition";
import { GROUP_NAME, GROUP_NUMBER } from "../../../../../../../../../constants/groups";

const PersonalInformation = (props: any) => {
	const [isPrintable, setIsPrintable] = useState(props.isPrintable);
	const [employee, setEmployee] = useState({ ...props?.employee });

	useEffect(() => {
		setEmployee(Object.assign({}, props.employee));
	}, [props.employee]);

	// if (employee == undefined) {
	// 	return <></>;
	// }
	// console.log("emp", employee);
	return (
		<div className="personal-information" id="personal-information">
			<div className="group-information">
				<Grid container spacing={1}>
					<Grid
						item
						xs={isPrintable ? 4 : 5}
						sm={isPrintable ? 4 : 5}
						md={isPrintable ? 4 : 5}
						lg={isPrintable ? 4 : 5}
						xl={isPrintable ? 4 : 5}
						className="grid-items"
					>
						<div className="label">
							{isPrintable ? "Group/Organization Name" : "Group/Employee/Participating Organization Name"}
						</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								name="group_name"
								value={
									employee.group_number === GROUP_NUMBER.BBI_BROOKSHIRE_BROTHERS
										? GROUP_NAME.BBI
										: "N/A"
								}
								// onChange={props.handleEnrollmentChange}
								style={{
									width: isPrintable ? "240px" : "360px",
									borderRadius: 50
								}}
								inputProps={{ readOnly: true }}
							/>
						</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">Country</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								name="country"
								value={employee.country}
								// onChange={props.handleEnrollmentChange}
								style={{
									// width: "390px",
									borderRadius: 50
								}}
								inputProps={{ readOnly: true }}
							/>
						</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">Zip</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								name="ZIP"
								// value={formatZIP(employee?.ZIP as string)}
								value={formatZIP(employee?.ZIP)}
								// onChange={props.handleEnrollmentChange}
								// onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => props.handleKeyCheck(event)}
								// onPaste={(event: React.ClipboardEvent<HTMLDivElement>) => props.handlePaste(event)}
								style={{
									// width: "390px",
									borderRadius: 50
								}}
								inputProps={{ readOnly: true }}
							/>
						</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">State</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								name="state"
								value={employee.state}
								// onChange={props.handleEnrollmentChange}
								style={{
									width: isPrintable ? "130px" : "",
									borderRadius: 50
								}}
								inputProps={{ readOnly: true }}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div className="self-information">
				<Grid container spacing={1}>
					<Grid item xs={5} sm={5} md={5} lg={5} xl={5} className="grid-items">
						<Grid container spacing={1}>
							<Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
								<div className={isPrintable ? "label-print" : "label"}>First Name</div>
								<div className="text-field">
									<TextField
										className="text-field"
										id="text-field"
										name="first_name"
										value={employee.first_name}
										// onChange={props.handleEnrollmentChange}
										style={{
											//width: "360px",
											borderRadius: 50
										}}
										inputProps={{ readOnly: true }}
									/>
								</div>
							</Grid>
							<Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
								<div className={isPrintable ? "label-print" : "label"}>Middle Name</div>
								<div className="text-field">
									<TextField
										className="text-field"
										id="text-field"
										name="middle_name"
										value={employee.middle_name}
										// onChange={props.handleEnrollmentChange}
										style={{
											//width: "360px",
											borderRadius: 50
										}}
										inputProps={{ readOnly: true }}
									/>
								</div>
							</Grid>
							<Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
								<div className={isPrintable ? "label-print" : "label"}>Last Name</div>
								<div className="text-field">
									<TextField
										className="text-field"
										id="text-field"
										name="last_name"
										value={employee.last_name}
										// onChange={props.handleEnrollmentChange}
										style={{
											//width: "360px",
											borderRadius: 50
										}}
										inputProps={{ readOnly: true }}
									/>
								</div>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="grid-items">
						<div className={isPrintable ? "label-ssn-print" : "label"}>Social Security No.</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								name="SSN"
								// value={formatSSN(employee.SSN)}
								value={formatSSN(employee.SSN)}
								// onChange={props.handleEnrollmentChange}
								// onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => props.handleKeyCheck(event)}
								// onPaste={(event: React.ClipboardEvent<HTMLDivElement>) => props.handlePaste(event)}
								style={{
									// width: "390px",
									borderRadius: 50
								}}
								inputProps={{ readOnly: true }}
							/>
						</div>
					</Grid>
					<Grid
						item
						xs={isPrintable ? 5 : 2}
						sm={isPrintable ? 5 : 2}
						md={isPrintable ? 5 : 2}
						lg={isPrintable ? 5 : 2}
						xl={isPrintable ? 5 : 2}
						className="grid-items"
					>
						<div className={isPrintable ? "label-print" : "label"}>Employee ID No.</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								name="employee_id"
								value={employee.member_id}
								// onChange={props.handleEnrollmentChange}
								style={{
									width: isPrintable ? "285px" : "",
									borderRadius: 50
								}}
								inputProps={{ readOnly: true }}
							/>
						</div>
					</Grid>
					<Grid
						item
						xs={isPrintable ? 4 : 2}
						sm={isPrintable ? 4 : 2}
						md={isPrintable ? 4 : 2}
						lg={isPrintable ? 4 : 2}
						xl={isPrintable ? 4 : 2}
						className="grid-items"
					>
						<div className={isPrintable ? "label-print" : "label"}>Date of Birth</div>
						<div className="text-field">
							<span className="textfield-container">
								<TextField
									className="date-field"
									id="text-field"
									placeholder="MM"
									name="month"
									value={prefixCharacterAddition(new Date(employee.date_of_birth).getMonth() + 1)}
									// onChange={props.handleDateOfBirthChange}
									style={{
										width: "30px",
										borderRadius: 50
									}}
								/>
							</span>
							/
							<span className="textfield-container">
								<TextField
									className="date-field"
									id="text-field"
									placeholder="DD"
									name="day"
									value={prefixCharacterAddition(new Date(employee.date_of_birth).getDate())}
									// onChange={props.handleDateOfBirthChange}
									style={{
										marginLeft: "3px",
										width: "30px",
										borderRadius: 50
									}}
								/>
							</span>
							/
							<span className="textfield-container">
								<TextField
									className="date-field"
									id="text-field"
									placeholder="YYYY"
									name="year"
									value={new Date(employee.date_of_birth).getFullYear()}
									// onChange={props.handleDateOfBirthChange}
									style={{
										marginLeft: "3px",
										width: isPrintable ? "40px" : "50px",
										borderRadius: 50
									}}
								/>
							</span>
						</div>
					</Grid>
				</Grid>
			</div>
			<div className="unique-information">
				<Grid container spacing={1}>
					<Grid item xs={5} sm={5} md={5} lg={5} xl={5} className="grid-items">
						<div className="label">Street Address (Include Apt. or Suite No.)</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								name="address"
								value={employee.address_line_1 + " " + employee.address_line_2}
								// onChange={props.handleEnrollmentChange}
								style={{
									width: isPrintable ? "300px" : "360px",
									borderRadius: 50
								}}
								inputProps={{ readOnly: true }}
							/>
						</div>
					</Grid>
					<Grid
						item
						xs={isPrintable ? 1 : 2}
						sm={isPrintable ? 1 : 2}
						md={isPrintable ? 1 : 2}
						lg={isPrintable ? 1 : 2}
						xl={isPrintable ? 1 : 2}
						className="grid-items"
					>
						<div className="label">City</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								name="city"
								value={employee.city}
								// onChange={props.handleEnrollmentChange}
								style={{
									width: isPrintable ? "70px" : "",
									borderRadius: 50
								}}
								inputProps={{ readOnly: true }}
							/>
						</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">State</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								name="state"
								value={employee.state}
								// onChange={props.handleEnrollmentChange}
								style={{
									width: isPrintable ? "130px" : "",
									borderRadius: 50
								}}
								inputProps={{ readOnly: true }}
							/>
						</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">Zip</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								name="ZIP"
								// value={formatZIP(employee?.ZIP)}
								value={formatZIP(employee?.ZIP)}
								// onChange={props.handleEnrollmentChange}
								// onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => props.handleKeyCheck(event)}
								// onPaste={(event: React.ClipboardEvent<HTMLDivElement>) => props.handlePaste(event)}
								style={{
									// width: "390px",
									borderRadius: 50
								}}
								inputProps={{ readOnly: true }}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div className="contact-information">
				<Grid container spacing={1}>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">Home Phone</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								name="home_phone"
								value={employee.contact_label === "HOME" ? employee.phone_number : ""}
								// onChange={props.handleEnrollmentChange}
								style={{
									// width: "360px",
									borderRadius: 50
								}}
								inputProps={{ readOnly: true }}
							/>
						</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">Cell Phone</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								name="cell_phone"
								value={employee.contact_label === "MOBILE" ? employee.phone_number : ""}
								// onChange={props.handleEnrollmentChange}
								style={{
									// width: "390px",
									borderRadius: 50
								}}
								inputProps={{ readOnly: true }}
							/>
						</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">Work Phone</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								name="work_phone"
								value={employee.contact_label === "BUSINESS" ? employee.phone_number : ""}
								// onChange={props.handleEnrollmentChange}
								style={{
									// width: "390px",
									borderRadius: 50
								}}
								inputProps={{ readOnly: true }}
							/>
						</div>
					</Grid>
					<Grid
						item
						xs={isPrintable ? 4 : 5}
						sm={isPrintable ? 4 : 5}
						md={isPrintable ? 4 : 5}
						lg={isPrintable ? 4 : 5}
						xl={isPrintable ? 4 : 5}
						className="grid-items"
					>
						<div className="label">Email</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								name="email"
								value={employee.email}
								// onChange={props.handleEnrollmentChange}
								style={{
									width: isPrintable ? "280px" : "290px",
									borderRadius: 50
								}}
								inputProps={{ readOnly: true }}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div className="status-information">
				<Grid container spacing={1}>
					<Grid
						item
						xs={isPrintable ? 5 : 4}
						sm={isPrintable ? 5 : 4}
						md={isPrintable ? 5 : 4}
						lg={isPrintable ? 5 : 4}
						xl={isPrintable ? 5 : 4}
						className="grid-items"
					>
						<span className="gender-label">Gender: </span>
						<span className="male-radio-field">
							<input
								type="checkbox"
								id="male"
								name="male"
								value="male"
								// onChange={props.handleCheck}
								checked={employee.gender === "MALE" ? true : false}
							/>
							  <label htmlFor="male">Male</label>
						</span>
						<span className="female-radio-field">
							<input
								type="checkbox"
								id="female"
								name="female"
								value="female"
								// onChange={props.handleCheck}
								checked={employee.gender === "FEMALE" ? true : false}
							/>
							  <label htmlFor="female">Female</label>
						</span>
					</Grid>
					<Grid
						item
						xs={isPrintable ? 5 : 4}
						sm={isPrintable ? 5 : 4}
						md={isPrintable ? 5 : 4}
						lg={isPrintable ? 5 : 4}
						xl={isPrintable ? 5 : 4}
						className="grid-items"
					>
						<span className="gender-label">Marital Status: </span>
						<span className="male-radio-field">
							<input
								type="checkbox"
								id="married"
								name="married"
								value="married"
								// onChange={props.handleCheck}
								checked={employee.marital_status === "MARRIED" ? true : false}
							/>
							  <label htmlFor="male">Married</label>
						</span>
						<span className="female-radio-field">
							<input
								type="checkbox"
								id="single"
								name="single"
								value="single"
								// onChange={props.handleCheck}
								checked={employee.marital_status === "SINGLE" ? true : false}
							/>
							  <label htmlFor="female">Single</label>
						</span>
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

export default PersonalInformation;
